/**
* This file was automatically generated by @cosmwasm/ts-codegen@0.35.7.
* DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
* and run the @cosmwasm/ts-codegen generate command to regenerate this file.
*/

var _0 = /*#__PURE__*/Object.freeze({
    __proto__: null
});

/**
* This file was automatically generated by @cosmwasm/ts-codegen@0.35.7.
* DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
* and run the @cosmwasm/ts-codegen generate command to regenerate this file.
*/
class CoconutBandwidthQueryClient {
    client;
    contractAddress;
    constructor(client, contractAddress) {
        this.client = client;
        this.contractAddress = contractAddress;
        this.getSpentCredential = this.getSpentCredential.bind(this);
        this.getAllSpentCredentials = this.getAllSpentCredentials.bind(this);
    }
    getSpentCredential = async ({ blindedSerialNumber }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_spent_credential: {
                blinded_serial_number: blindedSerialNumber
            }
        });
    };
    getAllSpentCredentials = async ({ limit, startAfter }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_all_spent_credentials: {
                limit,
                start_after: startAfter
            }
        });
    };
}
class CoconutBandwidthClient extends CoconutBandwidthQueryClient {
    client;
    sender;
    contractAddress;
    constructor(client, sender, contractAddress) {
        super(client, contractAddress);
        this.client = client;
        this.sender = sender;
        this.contractAddress = contractAddress;
        this.depositFunds = this.depositFunds.bind(this);
        this.spendCredential = this.spendCredential.bind(this);
        this.releaseFunds = this.releaseFunds.bind(this);
    }
    depositFunds = async ({ data }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            deposit_funds: {
                data
            }
        }, fee, memo, _funds);
    };
    spendCredential = async ({ data }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            spend_credential: {
                data
            }
        }, fee, memo, _funds);
    };
    releaseFunds = async ({ funds }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            release_funds: {
                funds
            }
        }, fee, memo, _funds);
    };
}

var _1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    CoconutBandwidthClient: CoconutBandwidthClient,
    CoconutBandwidthQueryClient: CoconutBandwidthQueryClient
});

/**
* This file was automatically generated by @cosmwasm/ts-codegen@0.35.7.
* DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
* and run the @cosmwasm/ts-codegen generate command to regenerate this file.
*/

var _2 = /*#__PURE__*/Object.freeze({
    __proto__: null
});

/**
* This file was automatically generated by @cosmwasm/ts-codegen@0.35.7.
* DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
* and run the @cosmwasm/ts-codegen generate command to regenerate this file.
*/
class CoconutDkgQueryClient {
    client;
    contractAddress;
    constructor(client, contractAddress) {
        this.client = client;
        this.contractAddress = contractAddress;
        this.getState = this.getState.bind(this);
        this.getCurrentEpochState = this.getCurrentEpochState.bind(this);
        this.getCurrentEpochThreshold = this.getCurrentEpochThreshold.bind(this);
        this.getEpochThreshold = this.getEpochThreshold.bind(this);
        this.canAdvanceState = this.canAdvanceState.bind(this);
        this.getRegisteredDealer = this.getRegisteredDealer.bind(this);
        this.getDealerDetails = this.getDealerDetails.bind(this);
        this.getCurrentDealers = this.getCurrentDealers.bind(this);
        this.getDealerIndices = this.getDealerIndices.bind(this);
        this.getDealingsMetadata = this.getDealingsMetadata.bind(this);
        this.getDealerDealingsStatus = this.getDealerDealingsStatus.bind(this);
        this.getDealingStatus = this.getDealingStatus.bind(this);
        this.getDealingChunkStatus = this.getDealingChunkStatus.bind(this);
        this.getDealingChunk = this.getDealingChunk.bind(this);
        this.getVerificationKey = this.getVerificationKey.bind(this);
        this.getVerificationKeys = this.getVerificationKeys.bind(this);
        this.getCw2ContractVersion = this.getCw2ContractVersion.bind(this);
    }
    getState = async () => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_state: {}
        });
    };
    getCurrentEpochState = async () => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_current_epoch_state: {}
        });
    };
    getCurrentEpochThreshold = async () => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_current_epoch_threshold: {}
        });
    };
    getEpochThreshold = async ({ epochId }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_epoch_threshold: {
                epoch_id: epochId
            }
        });
    };
    canAdvanceState = async () => {
        return this.client.queryContractSmart(this.contractAddress, {
            can_advance_state: {}
        });
    };
    getRegisteredDealer = async ({ dealerAddress, epochId }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_registered_dealer: {
                dealer_address: dealerAddress,
                epoch_id: epochId
            }
        });
    };
    getDealerDetails = async ({ dealerAddress }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_dealer_details: {
                dealer_address: dealerAddress
            }
        });
    };
    getCurrentDealers = async ({ limit, startAfter }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_current_dealers: {
                limit,
                start_after: startAfter
            }
        });
    };
    getDealerIndices = async ({ limit, startAfter }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_dealer_indices: {
                limit,
                start_after: startAfter
            }
        });
    };
    getDealingsMetadata = async ({ dealer, dealingIndex, epochId }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_dealings_metadata: {
                dealer,
                dealing_index: dealingIndex,
                epoch_id: epochId
            }
        });
    };
    getDealerDealingsStatus = async ({ dealer, epochId }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_dealer_dealings_status: {
                dealer,
                epoch_id: epochId
            }
        });
    };
    getDealingStatus = async ({ dealer, dealingIndex, epochId }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_dealing_status: {
                dealer,
                dealing_index: dealingIndex,
                epoch_id: epochId
            }
        });
    };
    getDealingChunkStatus = async ({ chunkIndex, dealer, dealingIndex, epochId }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_dealing_chunk_status: {
                chunk_index: chunkIndex,
                dealer,
                dealing_index: dealingIndex,
                epoch_id: epochId
            }
        });
    };
    getDealingChunk = async ({ chunkIndex, dealer, dealingIndex, epochId }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_dealing_chunk: {
                chunk_index: chunkIndex,
                dealer,
                dealing_index: dealingIndex,
                epoch_id: epochId
            }
        });
    };
    getVerificationKey = async ({ epochId, owner }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_verification_key: {
                epoch_id: epochId,
                owner
            }
        });
    };
    getVerificationKeys = async ({ epochId, limit, startAfter }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_verification_keys: {
                epoch_id: epochId,
                limit,
                start_after: startAfter
            }
        });
    };
    getCw2ContractVersion = async () => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_cw2_contract_version: {}
        });
    };
}
class CoconutDkgClient extends CoconutDkgQueryClient {
    client;
    sender;
    contractAddress;
    constructor(client, sender, contractAddress) {
        super(client, contractAddress);
        this.client = client;
        this.sender = sender;
        this.contractAddress = contractAddress;
        this.initiateDkg = this.initiateDkg.bind(this);
        this.registerDealer = this.registerDealer.bind(this);
        this.commitDealingsMetadata = this.commitDealingsMetadata.bind(this);
        this.commitDealingsChunk = this.commitDealingsChunk.bind(this);
        this.commitVerificationKeyShare = this.commitVerificationKeyShare.bind(this);
        this.verifyVerificationKeyShare = this.verifyVerificationKeyShare.bind(this);
        this.advanceEpochState = this.advanceEpochState.bind(this);
        this.triggerReset = this.triggerReset.bind(this);
        this.triggerResharing = this.triggerResharing.bind(this);
    }
    initiateDkg = async (fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            initiate_dkg: {}
        }, fee, memo, _funds);
    };
    registerDealer = async ({ announceAddress, bteKeyWithProof, identityKey, resharing }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            register_dealer: {
                announce_address: announceAddress,
                bte_key_with_proof: bteKeyWithProof,
                identity_key: identityKey,
                resharing
            }
        }, fee, memo, _funds);
    };
    commitDealingsMetadata = async ({ chunks, dealingIndex, resharing }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            commit_dealings_metadata: {
                chunks,
                dealing_index: dealingIndex,
                resharing
            }
        }, fee, memo, _funds);
    };
    commitDealingsChunk = async ({ chunk }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            commit_dealings_chunk: {
                chunk
            }
        }, fee, memo, _funds);
    };
    commitVerificationKeyShare = async ({ resharing, share }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            commit_verification_key_share: {
                resharing,
                share
            }
        }, fee, memo, _funds);
    };
    verifyVerificationKeyShare = async ({ owner, resharing }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            verify_verification_key_share: {
                owner,
                resharing
            }
        }, fee, memo, _funds);
    };
    advanceEpochState = async (fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            advance_epoch_state: {}
        }, fee, memo, _funds);
    };
    triggerReset = async (fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            trigger_reset: {}
        }, fee, memo, _funds);
    };
    triggerResharing = async (fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            trigger_resharing: {}
        }, fee, memo, _funds);
    };
}

var _3 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    CoconutDkgClient: CoconutDkgClient,
    CoconutDkgQueryClient: CoconutDkgQueryClient
});

/**
* This file was automatically generated by @cosmwasm/ts-codegen@0.35.7.
* DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
* and run the @cosmwasm/ts-codegen generate command to regenerate this file.
*/

var _4 = /*#__PURE__*/Object.freeze({
    __proto__: null
});

/**
* This file was automatically generated by @cosmwasm/ts-codegen@0.35.7.
* DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
* and run the @cosmwasm/ts-codegen generate command to regenerate this file.
*/
class MixnetQueryClient {
    client;
    contractAddress;
    constructor(client, contractAddress) {
        this.client = client;
        this.contractAddress = contractAddress;
        this.admin = this.admin.bind(this);
        this.getContractVersion = this.getContractVersion.bind(this);
        this.getCw2ContractVersion = this.getCw2ContractVersion.bind(this);
        this.getRewardingValidatorAddress = this.getRewardingValidatorAddress.bind(this);
        this.getStateParams = this.getStateParams.bind(this);
        this.getState = this.getState.bind(this);
        this.getRewardingParams = this.getRewardingParams.bind(this);
        this.getEpochStatus = this.getEpochStatus.bind(this);
        this.getCurrentIntervalDetails = this.getCurrentIntervalDetails.bind(this);
        this.getMixNodeBonds = this.getMixNodeBonds.bind(this);
        this.getMixNodesDetailed = this.getMixNodesDetailed.bind(this);
        this.getUnbondedMixNodes = this.getUnbondedMixNodes.bind(this);
        this.getUnbondedMixNodesByOwner = this.getUnbondedMixNodesByOwner.bind(this);
        this.getUnbondedMixNodesByIdentityKey = this.getUnbondedMixNodesByIdentityKey.bind(this);
        this.getOwnedMixnode = this.getOwnedMixnode.bind(this);
        this.getMixnodeDetails = this.getMixnodeDetails.bind(this);
        this.getMixnodeRewardingDetails = this.getMixnodeRewardingDetails.bind(this);
        this.getStakeSaturation = this.getStakeSaturation.bind(this);
        this.getUnbondedMixNodeInformation = this.getUnbondedMixNodeInformation.bind(this);
        this.getBondedMixnodeDetailsByIdentity = this.getBondedMixnodeDetailsByIdentity.bind(this);
        this.getGateways = this.getGateways.bind(this);
        this.getGatewayBond = this.getGatewayBond.bind(this);
        this.getOwnedGateway = this.getOwnedGateway.bind(this);
        this.getPreassignedGatewayIds = this.getPreassignedGatewayIds.bind(this);
        this.getNymNodeBondsPaged = this.getNymNodeBondsPaged.bind(this);
        this.getNymNodesDetailedPaged = this.getNymNodesDetailedPaged.bind(this);
        this.getUnbondedNymNode = this.getUnbondedNymNode.bind(this);
        this.getUnbondedNymNodesPaged = this.getUnbondedNymNodesPaged.bind(this);
        this.getUnbondedNymNodesByOwnerPaged = this.getUnbondedNymNodesByOwnerPaged.bind(this);
        this.getUnbondedNymNodesByIdentityKeyPaged = this.getUnbondedNymNodesByIdentityKeyPaged.bind(this);
        this.getOwnedNymNode = this.getOwnedNymNode.bind(this);
        this.getNymNodeDetails = this.getNymNodeDetails.bind(this);
        this.getNymNodeDetailsByIdentityKey = this.getNymNodeDetailsByIdentityKey.bind(this);
        this.getNodeRewardingDetails = this.getNodeRewardingDetails.bind(this);
        this.getNodeStakeSaturation = this.getNodeStakeSaturation.bind(this);
        this.getRoleAssignment = this.getRoleAssignment.bind(this);
        this.getRewardedSetMetadata = this.getRewardedSetMetadata.bind(this);
        this.getNodeDelegations = this.getNodeDelegations.bind(this);
        this.getDelegatorDelegations = this.getDelegatorDelegations.bind(this);
        this.getDelegationDetails = this.getDelegationDetails.bind(this);
        this.getAllDelegations = this.getAllDelegations.bind(this);
        this.getPendingOperatorReward = this.getPendingOperatorReward.bind(this);
        this.getPendingNodeOperatorReward = this.getPendingNodeOperatorReward.bind(this);
        this.getPendingDelegatorReward = this.getPendingDelegatorReward.bind(this);
        this.getEstimatedCurrentEpochOperatorReward = this.getEstimatedCurrentEpochOperatorReward.bind(this);
        this.getEstimatedCurrentEpochDelegatorReward = this.getEstimatedCurrentEpochDelegatorReward.bind(this);
        this.getPendingEpochEvents = this.getPendingEpochEvents.bind(this);
        this.getPendingIntervalEvents = this.getPendingIntervalEvents.bind(this);
        this.getPendingEpochEvent = this.getPendingEpochEvent.bind(this);
        this.getPendingIntervalEvent = this.getPendingIntervalEvent.bind(this);
        this.getNumberOfPendingEvents = this.getNumberOfPendingEvents.bind(this);
        this.getSigningNonce = this.getSigningNonce.bind(this);
    }
    admin = async () => {
        return this.client.queryContractSmart(this.contractAddress, {
            admin: {}
        });
    };
    getContractVersion = async () => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_contract_version: {}
        });
    };
    getCw2ContractVersion = async () => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_cw2_contract_version: {}
        });
    };
    getRewardingValidatorAddress = async () => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_rewarding_validator_address: {}
        });
    };
    getStateParams = async () => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_state_params: {}
        });
    };
    getState = async () => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_state: {}
        });
    };
    getRewardingParams = async () => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_rewarding_params: {}
        });
    };
    getEpochStatus = async () => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_epoch_status: {}
        });
    };
    getCurrentIntervalDetails = async () => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_current_interval_details: {}
        });
    };
    getMixNodeBonds = async ({ limit, startAfter }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_mix_node_bonds: {
                limit,
                start_after: startAfter
            }
        });
    };
    getMixNodesDetailed = async ({ limit, startAfter }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_mix_nodes_detailed: {
                limit,
                start_after: startAfter
            }
        });
    };
    getUnbondedMixNodes = async ({ limit, startAfter }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_unbonded_mix_nodes: {
                limit,
                start_after: startAfter
            }
        });
    };
    getUnbondedMixNodesByOwner = async ({ limit, owner, startAfter }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_unbonded_mix_nodes_by_owner: {
                limit,
                owner,
                start_after: startAfter
            }
        });
    };
    getUnbondedMixNodesByIdentityKey = async ({ identityKey, limit, startAfter }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_unbonded_mix_nodes_by_identity_key: {
                identity_key: identityKey,
                limit,
                start_after: startAfter
            }
        });
    };
    getOwnedMixnode = async ({ address }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_owned_mixnode: {
                address
            }
        });
    };
    getMixnodeDetails = async ({ mixId }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_mixnode_details: {
                mix_id: mixId
            }
        });
    };
    getMixnodeRewardingDetails = async ({ mixId }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_mixnode_rewarding_details: {
                mix_id: mixId
            }
        });
    };
    getStakeSaturation = async ({ mixId }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_stake_saturation: {
                mix_id: mixId
            }
        });
    };
    getUnbondedMixNodeInformation = async ({ mixId }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_unbonded_mix_node_information: {
                mix_id: mixId
            }
        });
    };
    getBondedMixnodeDetailsByIdentity = async ({ mixIdentity }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_bonded_mixnode_details_by_identity: {
                mix_identity: mixIdentity
            }
        });
    };
    getGateways = async ({ limit, startAfter }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_gateways: {
                limit,
                start_after: startAfter
            }
        });
    };
    getGatewayBond = async ({ identity }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_gateway_bond: {
                identity
            }
        });
    };
    getOwnedGateway = async ({ address }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_owned_gateway: {
                address
            }
        });
    };
    getPreassignedGatewayIds = async ({ limit, startAfter }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_preassigned_gateway_ids: {
                limit,
                start_after: startAfter
            }
        });
    };
    getNymNodeBondsPaged = async ({ limit, startAfter }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_nym_node_bonds_paged: {
                limit,
                start_after: startAfter
            }
        });
    };
    getNymNodesDetailedPaged = async ({ limit, startAfter }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_nym_nodes_detailed_paged: {
                limit,
                start_after: startAfter
            }
        });
    };
    getUnbondedNymNode = async ({ nodeId }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_unbonded_nym_node: {
                node_id: nodeId
            }
        });
    };
    getUnbondedNymNodesPaged = async ({ limit, startAfter }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_unbonded_nym_nodes_paged: {
                limit,
                start_after: startAfter
            }
        });
    };
    getUnbondedNymNodesByOwnerPaged = async ({ limit, owner, startAfter }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_unbonded_nym_nodes_by_owner_paged: {
                limit,
                owner,
                start_after: startAfter
            }
        });
    };
    getUnbondedNymNodesByIdentityKeyPaged = async ({ identityKey, limit, startAfter }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_unbonded_nym_nodes_by_identity_key_paged: {
                identity_key: identityKey,
                limit,
                start_after: startAfter
            }
        });
    };
    getOwnedNymNode = async ({ address }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_owned_nym_node: {
                address
            }
        });
    };
    getNymNodeDetails = async ({ nodeId }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_nym_node_details: {
                node_id: nodeId
            }
        });
    };
    getNymNodeDetailsByIdentityKey = async ({ nodeIdentity }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_nym_node_details_by_identity_key: {
                node_identity: nodeIdentity
            }
        });
    };
    getNodeRewardingDetails = async ({ nodeId }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_node_rewarding_details: {
                node_id: nodeId
            }
        });
    };
    getNodeStakeSaturation = async ({ nodeId }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_node_stake_saturation: {
                node_id: nodeId
            }
        });
    };
    getRoleAssignment = async ({ role }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_role_assignment: {
                role
            }
        });
    };
    getRewardedSetMetadata = async () => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_rewarded_set_metadata: {}
        });
    };
    getNodeDelegations = async ({ limit, nodeId, startAfter }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_node_delegations: {
                limit,
                node_id: nodeId,
                start_after: startAfter
            }
        });
    };
    getDelegatorDelegations = async ({ delegator, limit, startAfter }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_delegator_delegations: {
                delegator,
                limit,
                start_after: startAfter
            }
        });
    };
    getDelegationDetails = async ({ delegator, nodeId, proxy }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_delegation_details: {
                delegator,
                node_id: nodeId,
                proxy
            }
        });
    };
    getAllDelegations = async ({ limit, startAfter }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_all_delegations: {
                limit,
                start_after: startAfter
            }
        });
    };
    getPendingOperatorReward = async ({ address }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_pending_operator_reward: {
                address
            }
        });
    };
    getPendingNodeOperatorReward = async ({ nodeId }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_pending_node_operator_reward: {
                node_id: nodeId
            }
        });
    };
    getPendingDelegatorReward = async ({ address, nodeId, proxy }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_pending_delegator_reward: {
                address,
                node_id: nodeId,
                proxy
            }
        });
    };
    getEstimatedCurrentEpochOperatorReward = async ({ estimatedPerformance, estimatedWork, nodeId }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_estimated_current_epoch_operator_reward: {
                estimated_performance: estimatedPerformance,
                estimated_work: estimatedWork,
                node_id: nodeId
            }
        });
    };
    getEstimatedCurrentEpochDelegatorReward = async ({ address, estimatedPerformance, estimatedWork, nodeId }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_estimated_current_epoch_delegator_reward: {
                address,
                estimated_performance: estimatedPerformance,
                estimated_work: estimatedWork,
                node_id: nodeId
            }
        });
    };
    getPendingEpochEvents = async ({ limit, startAfter }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_pending_epoch_events: {
                limit,
                start_after: startAfter
            }
        });
    };
    getPendingIntervalEvents = async ({ limit, startAfter }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_pending_interval_events: {
                limit,
                start_after: startAfter
            }
        });
    };
    getPendingEpochEvent = async ({ eventId }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_pending_epoch_event: {
                event_id: eventId
            }
        });
    };
    getPendingIntervalEvent = async ({ eventId }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_pending_interval_event: {
                event_id: eventId
            }
        });
    };
    getNumberOfPendingEvents = async () => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_number_of_pending_events: {}
        });
    };
    getSigningNonce = async ({ address }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_signing_nonce: {
                address
            }
        });
    };
}
class MixnetClient extends MixnetQueryClient {
    client;
    sender;
    contractAddress;
    constructor(client, sender, contractAddress) {
        super(client, contractAddress);
        this.client = client;
        this.sender = sender;
        this.contractAddress = contractAddress;
        this.updateAdmin = this.updateAdmin.bind(this);
        this.updateRewardingValidatorAddress = this.updateRewardingValidatorAddress.bind(this);
        this.updateContractStateParams = this.updateContractStateParams.bind(this);
        this.updateCurrentNymNodeSemver = this.updateCurrentNymNodeSemver.bind(this);
        this.updateActiveSetDistribution = this.updateActiveSetDistribution.bind(this);
        this.updateRewardingParams = this.updateRewardingParams.bind(this);
        this.updateIntervalConfig = this.updateIntervalConfig.bind(this);
        this.beginEpochTransition = this.beginEpochTransition.bind(this);
        this.reconcileEpochEvents = this.reconcileEpochEvents.bind(this);
        this.assignRoles = this.assignRoles.bind(this);
        this.bondMixnode = this.bondMixnode.bind(this);
        this.bondMixnodeOnBehalf = this.bondMixnodeOnBehalf.bind(this);
        this.pledgeMore = this.pledgeMore.bind(this);
        this.pledgeMoreOnBehalf = this.pledgeMoreOnBehalf.bind(this);
        this.decreasePledge = this.decreasePledge.bind(this);
        this.decreasePledgeOnBehalf = this.decreasePledgeOnBehalf.bind(this);
        this.unbondMixnode = this.unbondMixnode.bind(this);
        this.unbondMixnodeOnBehalf = this.unbondMixnodeOnBehalf.bind(this);
        this.updateCostParams = this.updateCostParams.bind(this);
        this.updateMixnodeCostParamsOnBehalf = this.updateMixnodeCostParamsOnBehalf.bind(this);
        this.updateMixnodeConfig = this.updateMixnodeConfig.bind(this);
        this.updateMixnodeConfigOnBehalf = this.updateMixnodeConfigOnBehalf.bind(this);
        this.migrateMixnode = this.migrateMixnode.bind(this);
        this.bondGateway = this.bondGateway.bind(this);
        this.bondGatewayOnBehalf = this.bondGatewayOnBehalf.bind(this);
        this.unbondGateway = this.unbondGateway.bind(this);
        this.unbondGatewayOnBehalf = this.unbondGatewayOnBehalf.bind(this);
        this.updateGatewayConfig = this.updateGatewayConfig.bind(this);
        this.updateGatewayConfigOnBehalf = this.updateGatewayConfigOnBehalf.bind(this);
        this.migrateGateway = this.migrateGateway.bind(this);
        this.bondNymNode = this.bondNymNode.bind(this);
        this.unbondNymNode = this.unbondNymNode.bind(this);
        this.updateNodeConfig = this.updateNodeConfig.bind(this);
        this.delegate = this.delegate.bind(this);
        this.delegateToMixnodeOnBehalf = this.delegateToMixnodeOnBehalf.bind(this);
        this.undelegate = this.undelegate.bind(this);
        this.undelegateFromMixnodeOnBehalf = this.undelegateFromMixnodeOnBehalf.bind(this);
        this.rewardNode = this.rewardNode.bind(this);
        this.withdrawOperatorReward = this.withdrawOperatorReward.bind(this);
        this.withdrawOperatorRewardOnBehalf = this.withdrawOperatorRewardOnBehalf.bind(this);
        this.withdrawDelegatorReward = this.withdrawDelegatorReward.bind(this);
        this.withdrawDelegatorRewardOnBehalf = this.withdrawDelegatorRewardOnBehalf.bind(this);
        this.migrateVestedMixNode = this.migrateVestedMixNode.bind(this);
        this.migrateVestedDelegation = this.migrateVestedDelegation.bind(this);
    }
    updateAdmin = async ({ admin }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            update_admin: {
                admin
            }
        }, fee, memo, _funds);
    };
    updateRewardingValidatorAddress = async ({ address }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            update_rewarding_validator_address: {
                address
            }
        }, fee, memo, _funds);
    };
    updateContractStateParams = async ({ update }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            update_contract_state_params: {
                update
            }
        }, fee, memo, _funds);
    };
    updateCurrentNymNodeSemver = async ({ currentVersion }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            update_current_nym_node_semver: {
                current_version: currentVersion
            }
        }, fee, memo, _funds);
    };
    updateActiveSetDistribution = async ({ forceImmediately, update }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            update_active_set_distribution: {
                force_immediately: forceImmediately,
                update
            }
        }, fee, memo, _funds);
    };
    updateRewardingParams = async ({ forceImmediately, updatedParams }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            update_rewarding_params: {
                force_immediately: forceImmediately,
                updated_params: updatedParams
            }
        }, fee, memo, _funds);
    };
    updateIntervalConfig = async ({ epochDurationSecs, epochsInInterval, forceImmediately }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            update_interval_config: {
                epoch_duration_secs: epochDurationSecs,
                epochs_in_interval: epochsInInterval,
                force_immediately: forceImmediately
            }
        }, fee, memo, _funds);
    };
    beginEpochTransition = async (fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            begin_epoch_transition: {}
        }, fee, memo, _funds);
    };
    reconcileEpochEvents = async ({ limit }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            reconcile_epoch_events: {
                limit
            }
        }, fee, memo, _funds);
    };
    assignRoles = async ({ assignment }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            assign_roles: {
                assignment
            }
        }, fee, memo, _funds);
    };
    bondMixnode = async ({ costParams, mixNode, ownerSignature }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            bond_mixnode: {
                cost_params: costParams,
                mix_node: mixNode,
                owner_signature: ownerSignature
            }
        }, fee, memo, _funds);
    };
    bondMixnodeOnBehalf = async ({ costParams, mixNode, owner, ownerSignature }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            bond_mixnode_on_behalf: {
                cost_params: costParams,
                mix_node: mixNode,
                owner,
                owner_signature: ownerSignature
            }
        }, fee, memo, _funds);
    };
    pledgeMore = async (fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            pledge_more: {}
        }, fee, memo, _funds);
    };
    pledgeMoreOnBehalf = async ({ owner }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            pledge_more_on_behalf: {
                owner
            }
        }, fee, memo, _funds);
    };
    decreasePledge = async ({ decreaseBy }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            decrease_pledge: {
                decrease_by: decreaseBy
            }
        }, fee, memo, _funds);
    };
    decreasePledgeOnBehalf = async ({ decreaseBy, owner }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            decrease_pledge_on_behalf: {
                decrease_by: decreaseBy,
                owner
            }
        }, fee, memo, _funds);
    };
    unbondMixnode = async (fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            unbond_mixnode: {}
        }, fee, memo, _funds);
    };
    unbondMixnodeOnBehalf = async ({ owner }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            unbond_mixnode_on_behalf: {
                owner
            }
        }, fee, memo, _funds);
    };
    updateCostParams = async ({ newCosts }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            update_cost_params: {
                new_costs: newCosts
            }
        }, fee, memo, _funds);
    };
    updateMixnodeCostParamsOnBehalf = async ({ newCosts, owner }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            update_mixnode_cost_params_on_behalf: {
                new_costs: newCosts,
                owner
            }
        }, fee, memo, _funds);
    };
    updateMixnodeConfig = async ({ newConfig }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            update_mixnode_config: {
                new_config: newConfig
            }
        }, fee, memo, _funds);
    };
    updateMixnodeConfigOnBehalf = async ({ newConfig, owner }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            update_mixnode_config_on_behalf: {
                new_config: newConfig,
                owner
            }
        }, fee, memo, _funds);
    };
    migrateMixnode = async (fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            migrate_mixnode: {}
        }, fee, memo, _funds);
    };
    bondGateway = async ({ gateway, ownerSignature }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            bond_gateway: {
                gateway,
                owner_signature: ownerSignature
            }
        }, fee, memo, _funds);
    };
    bondGatewayOnBehalf = async ({ gateway, owner, ownerSignature }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            bond_gateway_on_behalf: {
                gateway,
                owner,
                owner_signature: ownerSignature
            }
        }, fee, memo, _funds);
    };
    unbondGateway = async (fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            unbond_gateway: {}
        }, fee, memo, _funds);
    };
    unbondGatewayOnBehalf = async ({ owner }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            unbond_gateway_on_behalf: {
                owner
            }
        }, fee, memo, _funds);
    };
    updateGatewayConfig = async ({ newConfig }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            update_gateway_config: {
                new_config: newConfig
            }
        }, fee, memo, _funds);
    };
    updateGatewayConfigOnBehalf = async ({ newConfig, owner }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            update_gateway_config_on_behalf: {
                new_config: newConfig,
                owner
            }
        }, fee, memo, _funds);
    };
    migrateGateway = async ({ costParams }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            migrate_gateway: {
                cost_params: costParams
            }
        }, fee, memo, _funds);
    };
    bondNymNode = async ({ costParams, node, ownerSignature }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            bond_nym_node: {
                cost_params: costParams,
                node,
                owner_signature: ownerSignature
            }
        }, fee, memo, _funds);
    };
    unbondNymNode = async (fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            unbond_nym_node: {}
        }, fee, memo, _funds);
    };
    updateNodeConfig = async ({ update }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            update_node_config: {
                update
            }
        }, fee, memo, _funds);
    };
    delegate = async ({ nodeId }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            delegate: {
                node_id: nodeId
            }
        }, fee, memo, _funds);
    };
    delegateToMixnodeOnBehalf = async ({ delegate, mixId }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            delegate_to_mixnode_on_behalf: {
                delegate,
                mix_id: mixId
            }
        }, fee, memo, _funds);
    };
    undelegate = async ({ nodeId }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            undelegate: {
                node_id: nodeId
            }
        }, fee, memo, _funds);
    };
    undelegateFromMixnodeOnBehalf = async ({ delegate, mixId }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            undelegate_from_mixnode_on_behalf: {
                delegate,
                mix_id: mixId
            }
        }, fee, memo, _funds);
    };
    rewardNode = async ({ nodeId, params }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            reward_node: {
                node_id: nodeId,
                params
            }
        }, fee, memo, _funds);
    };
    withdrawOperatorReward = async (fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            withdraw_operator_reward: {}
        }, fee, memo, _funds);
    };
    withdrawOperatorRewardOnBehalf = async ({ owner }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            withdraw_operator_reward_on_behalf: {
                owner
            }
        }, fee, memo, _funds);
    };
    withdrawDelegatorReward = async ({ nodeId }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            withdraw_delegator_reward: {
                node_id: nodeId
            }
        }, fee, memo, _funds);
    };
    withdrawDelegatorRewardOnBehalf = async ({ mixId, owner }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            withdraw_delegator_reward_on_behalf: {
                mix_id: mixId,
                owner
            }
        }, fee, memo, _funds);
    };
    migrateVestedMixNode = async (fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            migrate_vested_mix_node: {}
        }, fee, memo, _funds);
    };
    migrateVestedDelegation = async ({ mixId }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            migrate_vested_delegation: {
                mix_id: mixId
            }
        }, fee, memo, _funds);
    };
}

var _5 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    MixnetClient: MixnetClient,
    MixnetQueryClient: MixnetQueryClient
});

/**
* This file was automatically generated by @cosmwasm/ts-codegen@0.35.7.
* DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
* and run the @cosmwasm/ts-codegen generate command to regenerate this file.
*/

var _6 = /*#__PURE__*/Object.freeze({
    __proto__: null
});

/**
* This file was automatically generated by @cosmwasm/ts-codegen@0.35.7.
* DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
* and run the @cosmwasm/ts-codegen generate command to regenerate this file.
*/
class Cw3FlexMultisigQueryClient {
    client;
    contractAddress;
    constructor(client, contractAddress) {
        this.client = client;
        this.contractAddress = contractAddress;
        this.threshold = this.threshold.bind(this);
        this.proposal = this.proposal.bind(this);
        this.listProposals = this.listProposals.bind(this);
        this.reverseProposals = this.reverseProposals.bind(this);
        this.vote = this.vote.bind(this);
        this.listVotes = this.listVotes.bind(this);
        this.voter = this.voter.bind(this);
        this.listVoters = this.listVoters.bind(this);
        this.config = this.config.bind(this);
    }
    threshold = async () => {
        return this.client.queryContractSmart(this.contractAddress, {
            threshold: {}
        });
    };
    proposal = async ({ proposalId }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            proposal: {
                proposal_id: proposalId
            }
        });
    };
    listProposals = async ({ limit, startAfter }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            list_proposals: {
                limit,
                start_after: startAfter
            }
        });
    };
    reverseProposals = async ({ limit, startBefore }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            reverse_proposals: {
                limit,
                start_before: startBefore
            }
        });
    };
    vote = async ({ proposalId, voter }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            vote: {
                proposal_id: proposalId,
                voter
            }
        });
    };
    listVotes = async ({ limit, proposalId, startAfter }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            list_votes: {
                limit,
                proposal_id: proposalId,
                start_after: startAfter
            }
        });
    };
    voter = async ({ address }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            voter: {
                address
            }
        });
    };
    listVoters = async ({ limit, startAfter }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            list_voters: {
                limit,
                start_after: startAfter
            }
        });
    };
    config = async () => {
        return this.client.queryContractSmart(this.contractAddress, {
            config: {}
        });
    };
}
class Cw3FlexMultisigClient extends Cw3FlexMultisigQueryClient {
    client;
    sender;
    contractAddress;
    constructor(client, sender, contractAddress) {
        super(client, contractAddress);
        this.client = client;
        this.sender = sender;
        this.contractAddress = contractAddress;
        this.propose = this.propose.bind(this);
        this.vote = this.vote.bind(this);
        this.execute = this.execute.bind(this);
        this.close = this.close.bind(this);
        this.memberChangedHook = this.memberChangedHook.bind(this);
    }
    propose = async ({ description, latest, msgs, title }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            propose: {
                description,
                latest,
                msgs,
                title
            }
        }, fee, memo, _funds);
    };
    // vote = async ({
    //   proposalId,
    //   vote
    // }: {
    //   proposalId: number;
    //   vote: Vote;
    // }, fee: number | StdFee | "auto" = "auto", memo?: string, _funds?: Coin[]): Promise<ExecuteResult> => {
    //   return await this.client.execute(this.sender, this.contractAddress, {
    //     vote: {
    //       proposal_id: proposalId,
    //       vote
    //     }
    //   }, fee, memo, _funds);
    // };
    execute = async ({ proposalId }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            execute: {
                proposal_id: proposalId
            }
        }, fee, memo, _funds);
    };
    close = async ({ proposalId }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            close: {
                proposal_id: proposalId
            }
        }, fee, memo, _funds);
    };
    memberChangedHook = async ({ diffs }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            member_changed_hook: {
                diffs
            }
        }, fee, memo, _funds);
    };
}

var _7 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Cw3FlexMultisigClient: Cw3FlexMultisigClient,
    Cw3FlexMultisigQueryClient: Cw3FlexMultisigQueryClient
});

/**
* This file was automatically generated by @cosmwasm/ts-codegen@0.35.7.
* DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
* and run the @cosmwasm/ts-codegen generate command to regenerate this file.
*/

var _8 = /*#__PURE__*/Object.freeze({
    __proto__: null
});

/**
* This file was automatically generated by @cosmwasm/ts-codegen@0.35.7.
* DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
* and run the @cosmwasm/ts-codegen generate command to regenerate this file.
*/
class Cw4GroupQueryClient {
    client;
    contractAddress;
    constructor(client, contractAddress) {
        this.client = client;
        this.contractAddress = contractAddress;
        this.admin = this.admin.bind(this);
        this.totalWeight = this.totalWeight.bind(this);
        this.listMembers = this.listMembers.bind(this);
        this.member = this.member.bind(this);
        this.hooks = this.hooks.bind(this);
    }
    admin = async () => {
        return this.client.queryContractSmart(this.contractAddress, {
            admin: {}
        });
    };
    totalWeight = async ({ atHeight }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            total_weight: {
                at_height: atHeight
            }
        });
    };
    listMembers = async ({ limit, startAfter }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            list_members: {
                limit,
                start_after: startAfter
            }
        });
    };
    member = async ({ addr, atHeight }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            member: {
                addr,
                at_height: atHeight
            }
        });
    };
    hooks = async () => {
        return this.client.queryContractSmart(this.contractAddress, {
            hooks: {}
        });
    };
}
class Cw4GroupClient extends Cw4GroupQueryClient {
    client;
    sender;
    contractAddress;
    constructor(client, sender, contractAddress) {
        super(client, contractAddress);
        this.client = client;
        this.sender = sender;
        this.contractAddress = contractAddress;
        this.updateAdmin = this.updateAdmin.bind(this);
        this.updateMembers = this.updateMembers.bind(this);
        this.addHook = this.addHook.bind(this);
        this.removeHook = this.removeHook.bind(this);
    }
    updateAdmin = async ({ admin }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            update_admin: {
                admin
            }
        }, fee, memo, _funds);
    };
    updateMembers = async ({ add, remove }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            update_members: {
                add,
                remove
            }
        }, fee, memo, _funds);
    };
    addHook = async ({ addr }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            add_hook: {
                addr
            }
        }, fee, memo, _funds);
    };
    removeHook = async ({ addr }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            remove_hook: {
                addr
            }
        }, fee, memo, _funds);
    };
}

var _9 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Cw4GroupClient: Cw4GroupClient,
    Cw4GroupQueryClient: Cw4GroupQueryClient
});

/**
* This file was automatically generated by @cosmwasm/ts-codegen@0.35.7.
* DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
* and run the @cosmwasm/ts-codegen generate command to regenerate this file.
*/

var _10 = /*#__PURE__*/Object.freeze({
    __proto__: null
});

/**
* This file was automatically generated by @cosmwasm/ts-codegen@0.35.7.
* DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
* and run the @cosmwasm/ts-codegen generate command to regenerate this file.
*/
class VestingQueryClient {
    client;
    contractAddress;
    constructor(client, contractAddress) {
        this.client = client;
        this.contractAddress = contractAddress;
        this.getContractVersion = this.getContractVersion.bind(this);
        this.getCw2ContractVersion = this.getCw2ContractVersion.bind(this);
        this.getAccountsPaged = this.getAccountsPaged.bind(this);
        this.getAccountsVestingCoinsPaged = this.getAccountsVestingCoinsPaged.bind(this);
        this.lockedCoins = this.lockedCoins.bind(this);
        this.spendableCoins = this.spendableCoins.bind(this);
        this.getVestedCoins = this.getVestedCoins.bind(this);
        this.getVestingCoins = this.getVestingCoins.bind(this);
        this.getStartTime = this.getStartTime.bind(this);
        this.getEndTime = this.getEndTime.bind(this);
        this.getOriginalVesting = this.getOriginalVesting.bind(this);
        this.getHistoricalVestingStakingReward = this.getHistoricalVestingStakingReward.bind(this);
        this.getSpendableVestedCoins = this.getSpendableVestedCoins.bind(this);
        this.getSpendableRewardCoins = this.getSpendableRewardCoins.bind(this);
        this.getDelegatedCoins = this.getDelegatedCoins.bind(this);
        this.getPledgedCoins = this.getPledgedCoins.bind(this);
        this.getStakedCoins = this.getStakedCoins.bind(this);
        this.getWithdrawnCoins = this.getWithdrawnCoins.bind(this);
        this.getAccount = this.getAccount.bind(this);
        this.getMixnode = this.getMixnode.bind(this);
        this.getGateway = this.getGateway.bind(this);
        this.getCurrentVestingPeriod = this.getCurrentVestingPeriod.bind(this);
        this.getDelegation = this.getDelegation.bind(this);
        this.getTotalDelegationAmount = this.getTotalDelegationAmount.bind(this);
        this.getDelegationTimes = this.getDelegationTimes.bind(this);
        this.getAllDelegations = this.getAllDelegations.bind(this);
    }
    getContractVersion = async () => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_contract_version: {}
        });
    };
    getCw2ContractVersion = async () => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_cw2_contract_version: {}
        });
    };
    getAccountsPaged = async ({ limit, startNextAfter }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_accounts_paged: {
                limit,
                start_next_after: startNextAfter
            }
        });
    };
    getAccountsVestingCoinsPaged = async ({ limit, startNextAfter }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_accounts_vesting_coins_paged: {
                limit,
                start_next_after: startNextAfter
            }
        });
    };
    lockedCoins = async ({ blockTime, vestingAccountAddress }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            locked_coins: {
                block_time: blockTime,
                vesting_account_address: vestingAccountAddress
            }
        });
    };
    spendableCoins = async ({ blockTime, vestingAccountAddress }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            spendable_coins: {
                block_time: blockTime,
                vesting_account_address: vestingAccountAddress
            }
        });
    };
    getVestedCoins = async ({ blockTime, vestingAccountAddress }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_vested_coins: {
                block_time: blockTime,
                vesting_account_address: vestingAccountAddress
            }
        });
    };
    getVestingCoins = async ({ blockTime, vestingAccountAddress }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_vesting_coins: {
                block_time: blockTime,
                vesting_account_address: vestingAccountAddress
            }
        });
    };
    getStartTime = async ({ vestingAccountAddress }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_start_time: {
                vesting_account_address: vestingAccountAddress
            }
        });
    };
    getEndTime = async ({ vestingAccountAddress }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_end_time: {
                vesting_account_address: vestingAccountAddress
            }
        });
    };
    getOriginalVesting = async ({ vestingAccountAddress }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_original_vesting: {
                vesting_account_address: vestingAccountAddress
            }
        });
    };
    getHistoricalVestingStakingReward = async ({ vestingAccountAddress }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_historical_vesting_staking_reward: {
                vesting_account_address: vestingAccountAddress
            }
        });
    };
    getSpendableVestedCoins = async ({ vestingAccountAddress }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_spendable_vested_coins: {
                vesting_account_address: vestingAccountAddress
            }
        });
    };
    getSpendableRewardCoins = async ({ vestingAccountAddress }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_spendable_reward_coins: {
                vesting_account_address: vestingAccountAddress
            }
        });
    };
    getDelegatedCoins = async ({ vestingAccountAddress }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_delegated_coins: {
                vesting_account_address: vestingAccountAddress
            }
        });
    };
    getPledgedCoins = async ({ vestingAccountAddress }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_pledged_coins: {
                vesting_account_address: vestingAccountAddress
            }
        });
    };
    getStakedCoins = async ({ vestingAccountAddress }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_staked_coins: {
                vesting_account_address: vestingAccountAddress
            }
        });
    };
    getWithdrawnCoins = async ({ vestingAccountAddress }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_withdrawn_coins: {
                vesting_account_address: vestingAccountAddress
            }
        });
    };
    getAccount = async ({ address }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_account: {
                address
            }
        });
    };
    getMixnode = async ({ address }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_mixnode: {
                address
            }
        });
    };
    getGateway = async ({ address }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_gateway: {
                address
            }
        });
    };
    getCurrentVestingPeriod = async ({ address }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_current_vesting_period: {
                address
            }
        });
    };
    getDelegation = async ({ address, blockTimestampSecs, mixId }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_delegation: {
                address,
                block_timestamp_secs: blockTimestampSecs,
                mix_id: mixId
            }
        });
    };
    getTotalDelegationAmount = async ({ address, mixId }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_total_delegation_amount: {
                address,
                mix_id: mixId
            }
        });
    };
    getDelegationTimes = async ({ address, mixId }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_delegation_times: {
                address,
                mix_id: mixId
            }
        });
    };
    getAllDelegations = async ({ limit, startAfter }) => {
        return this.client.queryContractSmart(this.contractAddress, {
            get_all_delegations: {
                limit,
                start_after: startAfter
            }
        });
    };
}
class VestingClient extends VestingQueryClient {
    client;
    sender;
    contractAddress;
    constructor(client, sender, contractAddress) {
        super(client, contractAddress);
        this.client = client;
        this.sender = sender;
        this.contractAddress = contractAddress;
        this.trackReward = this.trackReward.bind(this);
        this.claimOperatorReward = this.claimOperatorReward.bind(this);
        this.claimDelegatorReward = this.claimDelegatorReward.bind(this);
        this.updateMixnodeCostParams = this.updateMixnodeCostParams.bind(this);
        this.updateMixnodeConfig = this.updateMixnodeConfig.bind(this);
        this.updateMixnetAddress = this.updateMixnetAddress.bind(this);
        this.delegateToMixnode = this.delegateToMixnode.bind(this);
        this.undelegateFromMixnode = this.undelegateFromMixnode.bind(this);
        this.createAccount = this.createAccount.bind(this);
        this.withdrawVestedCoins = this.withdrawVestedCoins.bind(this);
        this.trackUndelegation = this.trackUndelegation.bind(this);
        this.bondMixnode = this.bondMixnode.bind(this);
        this.pledgeMore = this.pledgeMore.bind(this);
        this.decreasePledge = this.decreasePledge.bind(this);
        this.unbondMixnode = this.unbondMixnode.bind(this);
        this.trackUnbondMixnode = this.trackUnbondMixnode.bind(this);
        this.trackDecreasePledge = this.trackDecreasePledge.bind(this);
        this.bondGateway = this.bondGateway.bind(this);
        this.unbondGateway = this.unbondGateway.bind(this);
        this.trackUnbondGateway = this.trackUnbondGateway.bind(this);
        this.updateGatewayConfig = this.updateGatewayConfig.bind(this);
        this.transferOwnership = this.transferOwnership.bind(this);
        this.updateStakingAddress = this.updateStakingAddress.bind(this);
        this.updateLockedPledgeCap = this.updateLockedPledgeCap.bind(this);
        this.trackMigratedMixnode = this.trackMigratedMixnode.bind(this);
        this.trackMigratedDelegation = this.trackMigratedDelegation.bind(this);
    }
    trackReward = async ({ address, amount }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            track_reward: {
                address,
                amount
            }
        }, fee, memo, _funds);
    };
    claimOperatorReward = async (fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            claim_operator_reward: {}
        }, fee, memo, _funds);
    };
    claimDelegatorReward = async ({ mixId }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            claim_delegator_reward: {
                mix_id: mixId
            }
        }, fee, memo, _funds);
    };
    updateMixnodeCostParams = async ({ newCosts }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            update_mixnode_cost_params: {
                new_costs: newCosts
            }
        }, fee, memo, _funds);
    };
    updateMixnodeConfig = async ({ newConfig }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            update_mixnode_config: {
                new_config: newConfig
            }
        }, fee, memo, _funds);
    };
    updateMixnetAddress = async ({ address }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            update_mixnet_address: {
                address
            }
        }, fee, memo, _funds);
    };
    delegateToMixnode = async ({ amount, mixId, onBehalfOf }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            delegate_to_mixnode: {
                amount,
                mix_id: mixId,
                on_behalf_of: onBehalfOf
            }
        }, fee, memo, _funds);
    };
    undelegateFromMixnode = async ({ mixId, onBehalfOf }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            undelegate_from_mixnode: {
                mix_id: mixId,
                on_behalf_of: onBehalfOf
            }
        }, fee, memo, _funds);
    };
    createAccount = async ({ cap, ownerAddress, stakingAddress, vestingSpec }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            create_account: {
                cap,
                owner_address: ownerAddress,
                staking_address: stakingAddress,
                vesting_spec: vestingSpec
            }
        }, fee, memo, _funds);
    };
    withdrawVestedCoins = async ({ amount }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            withdraw_vested_coins: {
                amount
            }
        }, fee, memo, _funds);
    };
    trackUndelegation = async ({ amount, mixId, owner }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            track_undelegation: {
                amount,
                mix_id: mixId,
                owner
            }
        }, fee, memo, _funds);
    };
    bondMixnode = async ({ amount, costParams, mixNode, ownerSignature }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            bond_mixnode: {
                amount,
                cost_params: costParams,
                mix_node: mixNode,
                owner_signature: ownerSignature
            }
        }, fee, memo, _funds);
    };
    pledgeMore = async ({ amount }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            pledge_more: {
                amount
            }
        }, fee, memo, _funds);
    };
    decreasePledge = async ({ amount }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            decrease_pledge: {
                amount
            }
        }, fee, memo, _funds);
    };
    unbondMixnode = async (fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            unbond_mixnode: {}
        }, fee, memo, _funds);
    };
    trackUnbondMixnode = async ({ amount, owner }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            track_unbond_mixnode: {
                amount,
                owner
            }
        }, fee, memo, _funds);
    };
    trackDecreasePledge = async ({ amount, owner }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            track_decrease_pledge: {
                amount,
                owner
            }
        }, fee, memo, _funds);
    };
    bondGateway = async ({ amount, gateway, ownerSignature }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            bond_gateway: {
                amount,
                gateway,
                owner_signature: ownerSignature
            }
        }, fee, memo, _funds);
    };
    unbondGateway = async (fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            unbond_gateway: {}
        }, fee, memo, _funds);
    };
    trackUnbondGateway = async ({ amount, owner }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            track_unbond_gateway: {
                amount,
                owner
            }
        }, fee, memo, _funds);
    };
    updateGatewayConfig = async ({ newConfig }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            update_gateway_config: {
                new_config: newConfig
            }
        }, fee, memo, _funds);
    };
    transferOwnership = async ({ toAddress }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            transfer_ownership: {
                to_address: toAddress
            }
        }, fee, memo, _funds);
    };
    updateStakingAddress = async ({ toAddress }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            update_staking_address: {
                to_address: toAddress
            }
        }, fee, memo, _funds);
    };
    updateLockedPledgeCap = async ({ address, cap }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            update_locked_pledge_cap: {
                address,
                cap
            }
        }, fee, memo, _funds);
    };
    trackMigratedMixnode = async ({ owner }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            track_migrated_mixnode: {
                owner
            }
        }, fee, memo, _funds);
    };
    trackMigratedDelegation = async ({ mixId, owner }, fee = "auto", memo, _funds) => {
        return await this.client.execute(this.sender, this.contractAddress, {
            track_migrated_delegation: {
                mix_id: mixId,
                owner
            }
        }, fee, memo, _funds);
    };
}

var _11 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    VestingClient: VestingClient,
    VestingQueryClient: VestingQueryClient
});

/**
* This file was automatically generated by @cosmwasm/ts-codegen@0.35.7.
* DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
* and run the @cosmwasm/ts-codegen generate command to regenerate this file.
*/
var contracts;
(function (contracts) {
    contracts.CoconutBandwidth = { ..._0,
        ..._1
    };
    contracts.CoconutDkg = { ..._2,
        ..._3
    };
    contracts.Mixnet = { ..._4,
        ..._5
    };
    contracts.Cw3FlexMultisig = { ..._6,
        ..._7
    };
    contracts.Cw4Group = { ..._8,
        ..._9
    };
    contracts.Vesting = { ..._10,
        ..._11
    };
})(contracts || (contracts = {}));

export { contracts };
